export default class NewsletterBanner extends HTMLElement {
    constructor() {
        super();
    }
}

window.customElements.define('nc-newsletter-banner', NewsletterBanner);
